import React from 'react'

const Head = (props) => {
    return (
        <section className="position-relative section__head">
            <img src="./../images/Clip path group 2.png" className="images__leaf-or-1" alt="" />
            <img src="./../images/Clip path group.png" className="images__leaf-or-2" alt="" />
            <div className="container position-relative z-2">
                <div className="text-center">
                    <h1 className='text-capitalize font__size--70 text__70-1024 text__70-md text__70-sm normal text-capitalize'>{props.title}</h1>
                    <p className="medium font__size--16 text__16-1024 color__gray-1 text-capitalize"><span className='color__orange'>Home  /</span> {props.to}</p>
                </div>
            </div>
        </section>
    )
}

export default Head